/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionNotificationTeamsWebhook {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    constructor() {
        this.setDiscriminator("ScheduleExecutionNotificationTeamsWebhook");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionNotificationTeamsWebhook.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionNotificationTeamsWebhook>): ScheduleExecutionNotificationTeamsWebhook {
        let obj = Object.assign(new ScheduleExecutionNotificationTeamsWebhook(), model);
        ScheduleExecutionNotificationTeamsWebhook.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionNotificationTeamsWebhook>): ScheduleExecutionNotificationTeamsWebhook {
        if (!model) return null;
        return ScheduleExecutionNotificationTeamsWebhook.newInstance(<ScheduleExecutionNotificationTeamsWebhook> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionNotificationTeamsWebhook) {
        if (!obj) return;

        models.ScheduleExecutionNotificationTeamsWebhook.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionNotificationTeamsWebhook): boolean {
        switch (obj.__type)
        {
            case "ScheduleExecutionNotificationTeamsWebhook":
                Object.setPrototypeOf(obj, ScheduleExecutionNotificationTeamsWebhook.prototype);
                break;
            case "ScheduleExecutionNotificationForTeamsWebHook":
                Object.setPrototypeOf(obj, models.ScheduleExecutionNotificationForTeamsWebHook.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ScheduleExecutionNotificationTeamsWebhook)[] {
        return [
            models.ScheduleExecutionNotificationForTeamsWebHook,
        ];
    }

    fixupFields() {
    }

    /**
     * Teams webhook ID to trigger notification
     */
    webhook_id: string;

}
